import { render } from "./PermissionForm.vue?vue&type=template&id=4763b900&scoped=true&ts=true"
import script from "./PermissionForm.vue?vue&type=script&lang=ts"
export * from "./PermissionForm.vue?vue&type=script&lang=ts"

import "./PermissionForm.vue?vue&type=style&index=0&id=4763b900&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4763b900"]])

export default __exports__